module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_desktop_02.b6fd661b.svg";